import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {routing} from '../../app.routing';
import {CustomerOverviewModule} from '~features/customer-overview/customer-overview.module';
import {BreadcrumbsComponent} from './breadcrumbs/breadcrumbs.component';
import {ClubShellComponent} from '../routing/club-shell/club-shell.component';
import {CustomerShellComponent} from '../routing/customer-shell/customer-shell.component';
import {FooterComponent} from './footer/footer.component';
import {HeaderShellComponent} from '../routing/header-shell/header-shell.component';
import {HeaderComponent} from './header/header.component';
import {SidebarComponent} from './sidebar/sidebar.component';
import {ClubSettingsSidebarComponent} from './sidebar/sidebars/club-settings-sidebar.component';
import {CustomerOverviewSidebarComponent} from './sidebar/sidebars/customer-overview-sidebar.component';
import {CustomerSearchSidebarComponent} from './sidebar/sidebars/customer-search.component';
import {ImportsSidebarComponent} from './sidebar/sidebars/imports-sidebar.component';
import {RemindersSidebarComponent} from './sidebar/sidebars/reminders-sidebar.component';
import {SidebarBaseComponent} from './sidebar/sidebars/sidebar-base.component';
import {TixxSelectSidebarComponent} from './sidebar/sidebars/tixx-select-sidebar.component';
import {UserProfileSidebarComponent} from './sidebar/sidebars/user-profile-sidebar.component';
import {SvgComponent} from './svg/svg.component';
import {TixxSelectShellComponent} from '../routing/tixx-select-shell/tixx-select-shell.component';
import {TixxFanPortalSidebarComponent} from './sidebar/sidebars/tixx-fan-portal-sidebar.component';
import {TablesModule} from '~shared/components/tables/tables.module';
import {TixxConnectionComponent} from '~shared/components/tixx-connection/tixx-connection.component';
import {ButtonsModule} from '~shared/components/buttons/buttons.module';
import {MenuItemDirective} from './sidebar/menu-item.directive';
import {TixxSelectModule} from "~features/tixx-select/tixx-select.module";
import {TixxSelectViewComponent} from "~features/customer-overview/components/forms/tixx-select-view/tixx-select-view.component";

/**
 * Module for the navigation part of the page
 */
@NgModule({
  declarations: [
    SidebarComponent,
    SidebarBaseComponent,
    SvgComponent,
    HeaderComponent,
    FooterComponent,
    BreadcrumbsComponent,
    ClubSettingsSidebarComponent,
    ImportsSidebarComponent,
    CustomerOverviewSidebarComponent,
    CustomerSearchSidebarComponent,
    UserProfileSidebarComponent,
    HeaderShellComponent,
    ClubShellComponent,
    CustomerShellComponent,
    TixxSelectShellComponent,
    TixxConnectionComponent,
    MenuItemDirective,
    RemindersSidebarComponent,
    TixxSelectSidebarComponent,
    TixxSelectViewComponent,
    TixxFanPortalSidebarComponent
  ],
  exports: [
    SidebarComponent,
    SidebarBaseComponent,
    SvgComponent,
    HeaderComponent,
    FooterComponent,
    BreadcrumbsComponent,
    ClubSettingsSidebarComponent,
    ImportsSidebarComponent,
    CustomerOverviewSidebarComponent,
    CustomerSearchSidebarComponent,
    UserProfileSidebarComponent,
    HeaderShellComponent,
    ClubShellComponent,
    CustomerShellComponent,
    TixxSelectShellComponent,
    TixxConnectionComponent,
    MenuItemDirective,
    RemindersSidebarComponent,
    TixxSelectSidebarComponent,
    TixxSelectViewComponent,
    TixxFanPortalSidebarComponent
  ],
  imports: [
    CommonModule,
    routing,
    CustomerOverviewModule,
    TixxSelectModule,
    ButtonsModule,
    TablesModule,
  ]
})
export class NavigationModule {
}
